import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanActivateBasic } from './can-activate-basic';
import { CanActivateExternalPortal } from './can-activate-external-portal';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'apps',
    pathMatch: 'full',
  },
  {
    path: 'apps',
    children: [
      {
        path: '',
        redirectTo: 'core/index',
        pathMatch: 'full',
      },
      {
        path: 'core',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/core/core.module').then((m) => m.CoreModule),
      },
      {
        path: 'apps-management',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/apps-management/apps-management.module').then((m) => m.AppsManagementModule),
      },
      {
        path: 'authentication',
        loadChildren: () =>
          import('./apps/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'inventory',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/inventory/inventory.module').then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: 'crm',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/crm/crm.module').then((m) => m.CrmModule),
      },
      {
        path: 'subscription',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/subscription/subscription.module').then(
            (m) => m.SubscriptionModule
          ),
      },
      {
        path: 'translation',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/translation/translation.module').then(
            (m) => m.TranslationModule
          ),
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./apps/payment/payment.module').then((m) => m.PaymentModule),
      },
      {
        path: 'expense',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/expense/expense.module').then((m) => m.ExpenseModule),
      },
      {
        path: 'timesheet',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/timesheet/timesheet.module').then((m) => m.TimesheetModule),
      },
      {
        path: 'banking',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/banking/banking.module').then((m) => m.BankingModule),
      },
      {
        path: 'admin',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./apps/documents/documents.module').then(
            (m) => m.DocumentsModule
          ),
      },
      {
        path: 'shoppingCart',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/shoppingCart/shoppingCart.module').then(
            (m) => m.ShoppingCartModule
          ),
      },
      {
        path: 'external-portal',
        canActivate: [CanActivateExternalPortal],
        loadChildren: () =>
          import('./apps/external-portal/external-portal.module').then(
            (m) => m.ExternalPortalModule
          ),
      },
      {
        path: 'coming-soon',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/coming-soon/coming-soon.module').then(
            (m) => m.ComingSoonModule
          ),
      },
      {
        path: 'helpdesk',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/help-desk/help-desk.module').then(
            (m) => m.HelpDeskModule
          ),
      },
      {
        path: 'websites',
        canActivate: [CanActivateBasic],
        loadChildren: () =>
          import('./apps/website/website.module').then(m => m.WebsiteModule)
      }
    ],
  },
  {
    path: 'global',
    loadChildren: () => import('./apps/global-site/global-site.module')
      .then(g => g.GlobalSiteModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
